var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.valMask),expression:"valMask"}],attrs:{"inputmode":"numeric","label":"Validade","placeholder":"MM/YYYY","hide-details":""}})}
var staticRenderFns = []

export { render, staticRenderFns }